import { isFailedStatus } from './statusPredicates';

export function getLocalFailedFileCount(completionSummary) {
  return completionSummary?.errorCount ?? 0;
}

export function getRemoteFailedFileCount(remoteStatusSummary) {
  return Array.isArray(remoteStatusSummary?.files)
    ? remoteStatusSummary.files.filter((item) => isFailedStatus(item?.status)).length
    : 0;
}

export function getTotalFailedFileCount(localFailedFileCount, remoteFailedFileCount) {
  return localFailedFileCount + remoteFailedFileCount;
}
